var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOfficeAvatar7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8,
    cx: 35.0456,
    cy: 35.0454,
    r: 33.3766,
    fill: "#DFEBEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.966 18.3572H31.7079L32.1251 27.953L31.7079 31.2906L30.8735 33.7939L29.2047 35.4627L26.7014 37.9659L28.3702 38.8004L31.7079 39.2176H35.4628L36.7144 38.3832H38.3832L40.4693 37.9659H42.1381H43.3897L41.3037 35.8799L40.0521 34.6283L38.8004 32.9595L38.3832 30.8734L37.966 29.6218V18.3572Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1953 13.5175C26.1491 13.5175 25.2059 14.1477 24.8055 15.1143C24.4051 16.0808 24.6264 17.1934 25.3662 17.9332L27.1953 19.7623V29.4814C27.1953 30.1674 26.9228 30.8254 26.4377 31.3105L16.0909 41.6572C11.2024 46.5458 14.6646 54.9045 21.5781 54.9045H48.3326C55.2461 54.9045 58.7084 46.5458 53.8198 41.6572L43.473 31.3105C42.9879 30.8254 42.7154 30.1674 42.7154 29.4814V19.7623L44.5445 17.9332C45.2843 17.1934 45.5056 16.0808 45.1052 15.1143C44.7048 14.1477 43.7616 13.5175 42.7154 13.5175H27.1953ZM32.3687 29.4814V18.6908H37.542V29.4814C37.542 31.5395 38.3596 33.5133 39.8149 34.9686L42.4729 37.6265C40.6186 37.1952 38.6745 37.2825 36.8567 37.8885L35.6405 38.2938C33.5166 39.0018 31.2205 39.0018 29.0966 38.2938L27.6417 37.8089C27.5432 37.7761 27.4442 37.7463 27.3447 37.7197L30.0958 34.9686C31.5511 33.5133 32.3687 31.5395 32.3687 29.4814Z",
    fill: "#307F92"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1953 13.5175C26.1491 13.5175 25.2059 14.1477 24.8055 15.1143C24.4051 16.0808 24.6264 17.1934 25.3662 17.9332L27.1953 19.7623V29.4814C27.1953 30.1674 26.9228 30.8254 26.4377 31.3105L16.0909 41.6572C11.2024 46.5458 14.6646 54.9045 21.5781 54.9045H48.3326C55.2461 54.9045 58.7084 46.5458 53.8198 41.6572L43.473 31.3105C42.9879 30.8254 42.7154 30.1674 42.7154 29.4814V19.7623L44.5445 17.9332C45.2843 17.1934 45.5056 16.0808 45.1052 15.1143C44.7048 14.1477 43.7616 13.5175 42.7154 13.5175H27.1953ZM32.3687 29.4814V18.6908H37.542V29.4814C37.542 31.5395 38.3596 33.5133 39.8149 34.9686L42.4729 37.6265C40.6186 37.1952 38.6745 37.2825 36.8567 37.8885L35.6405 38.2938C33.5166 39.0018 31.2205 39.0018 29.0966 38.2938L27.6417 37.8089C27.5432 37.7761 27.4442 37.7463 27.3447 37.7197L30.0958 34.9686C31.5511 33.5133 32.3687 31.5395 32.3687 29.4814Z",
    fill: "#307F92"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficeAvatar7);
export default __webpack_public_path__ + "static/media/Office-Avatar-7.77a296301633d1442e9067040f434cb2.svg";
export { ForwardRef as ReactComponent };